import React, { useEffect, useState } from "react";
import { getWineSearcher } from "../../../../lib/wineRequests";
import WineSearcherResult from "./WineSearcherResult";

const WineSearcher = (props: {
  wine_id: number;
}) => {
  const [maxNearby, setMaxNearby] = useState(4);
  const [maxElse, setMaxElse] = useState(4);
  const [nearbyResults, setNearbyResults] = useState([]);
  const [otherResults, setOtherResults] = useState([]);
  
  const loadWineSearcher = async () => {
    const response = await getWineSearcher(props.wine_id);

    if(response?.data?.sellers) {
      setOtherResults(response.data.sellers);
    }
  }

  useEffect(() => {
    loadWineSearcher();
  }, [ props.wine_id ])

  return (
    <div className="space-y-8">
      {
        nearbyResults.length > 0 ? 
        <div>
          <div className="font-bold mb-2">Nearby (60 mile / 100km radius)</div>
          <div className="grid gap-4 grid-cols-1 lg:grid-cols-2">
            {
              nearbyResults.slice(0,maxNearby).map((result, idx) => <WineSearcherResult key={idx} result={result} />)
            }
            {
              nearbyResults.length > 4 && maxNearby != 99 &&
              <div 
                className="text-red text-center lg:col-span-2 py-2 cursor-pointer"
                onClick={() => {
                  setMaxNearby(99);
                }}
                onKeyDown={(e) => {
                  if(e.key === "Enter") {
                    setMaxNearby(99);
                  }
                }}
                role="button"
                tabIndex={0}
              >
                View All
              </div>            
            }
          </div>
        </div>
        : <div>
          
        </div>
      }

      {
        otherResults.length > 0 ? 
        <div>
          <div className="font-bold mb-2">Elsewhere</div>
          <div className="grid gap-4 grid-cols-1 lg:grid-cols-2">
            {
              otherResults.slice(0,maxElse).map((result, idx) => <WineSearcherResult key={idx} result={result} />)
            }
            {
              otherResults.length > 4 && maxElse != 99 &&
              <div 
                className="text-red text-center lg:col-span-2 py-2 cursor-pointer"
                onClick={() => {
                  setMaxElse(99);
                }}
                onKeyDown={(e) => {
                  if(e.key === "Enter") {
                    setMaxElse(99);
                  }
                }}
                role="button"
                tabIndex={0}
              >
                View All
              </div>
            }
          </div>
        </div>
        : <div>
          
        </div>
      }
    </div>
  )
}

export default WineSearcher;
